<template>
	<div v-if="store.cartTotalItems" class="flex-col w-full justify-between space-y-1 p-4 text-sm text-ihh-midnight-gray border-ihh-gray/40 border-t">
		<!-- Subtotal -->
		<div class="flex w-full justify-between text-ihh-midnight-gray">
			<div>Subtotal</div>
			<div>
				{{ (store.cart.subTotal || store.cartSubtotal).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}
			</div>
		</div>

		<!-- Shipping -->
		<div class="w-full flex m-auto items-center justify-between mb-1">
			<div class="flex-grow">
				<div class="">Shipping:</div>
			</div>
			<div class="w-16 text-right font-normal">{{ shippingText }}</div>
		</div>

		<!-- Tax -->
		<div v-for="tax in taxes" class="flex m-auto items-center justify-between mb-1 w-full">
			<div class="whitespace-nowrap">{{ tax.name }}:</div>
			<Spinner v-if="store.cart.tax === null" :small="true" class="w-4 h-4" color="border-t-ihh-salmon" />
			<div v-else>
				{{ tax.amount?.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}
			</div>
		</div>
	</div>

	<div v-if="store.cartTotalItems" class="flex m-auto items-center w-full justify-between px-4 text-ihh-midnight-gray font-semibold">
		<div class="text-sm sm:text-base">Total (USD)</div>
		<Spinner v-if="store.cart.tax === null" :small="true" class="w-4 h-4" color="border-t-ihh-salmon" />
		<div class="text-2xl sm:text-3xl font-bold" v-else>
			{{ checkout.displayTotal?.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}
		</div>
	</div>
</template>

<script>
export default {
	name: 'ExpressCheckoutSummary',
	inject: ['store', 'checkout'],
	data() {
		return {}
	},
	methods: {},
	computed: {
		shippingText() {
			if (!this.checkout.shipping.selectedShipping?.id) return '--'
			const cost = this.checkout.shipping.selectedShipping?.cost
			return cost === 0 ? 'FREE' : cost?.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
		},
		taxes() {
			return this.checkout.payment.taxes
		},
	},
}
</script>

<style scoped></style>
